/**
 * IANA zone ids for the General Settings picker.
 * Backend timezone validation (Luxon) remains authoritative.
 */
const FALLBACK_IANA_TIMEZONES = [
  "UTC",
  "Africa/Cairo",
  "America/Los_Angeles",
  "America/New_York",
  "America/Sao_Paulo",
  "Asia/Dubai",
  "Asia/Jerusalem",
  "Asia/Kolkata",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
  "Europe/Berlin",
  "Europe/London",
  "Europe/Paris",
  "Pacific/Auckland",
] as const;

let cachedTimezones: string[] | null = null;

export function listIanaTimezones(): string[] {
  if (cachedTimezones) return cachedTimezones;
  if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
    try {
      const supported = Intl.supportedValuesOf("timeZone");
      if (supported.length > 0) {
        cachedTimezones = supported;
        return cachedTimezones;
      }
    } catch {
      // Use the fallback catalog when the runtime list is unavailable.
    }
  }
  cachedTimezones = [...FALLBACK_IANA_TIMEZONES];
  return cachedTimezones;
}

export function knownIanaTimezoneSet(): ReadonlySet<string> {
  return new Set(listIanaTimezones());
}

export function filterIanaTimezones(zones: readonly string[], query: string): string[] {
  const needle = query.trim().toLowerCase();
  if (needle.length === 0) return [...zones];
  return zones.filter((zone) => zone.toLowerCase().includes(needle));
}

export function isKnownIanaTimezone(
  timezone: string,
  known: ReadonlySet<string> = knownIanaTimezoneSet(),
): boolean {
  return known.has(timezone);
}
